import { CONTACT } from "../content/site";
import { trackWa } from "./analytics";

// Explicit Unicode escape for U+1F48B (💋). Using the escape (not the literal
// glyph in every source file) guarantees the byte sequence in the compiled
// bundle regardless of editor/save/tooling encoding — WhatsApp's own upstream
// redirect can still mangle it, but our outbound wa.me URL is always correct.
export const KISS = "\u{1F48B}";

export function waLink(message) {
  const base = `https://wa.me/${CONTACT.waNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function openWA(message, source) {
  if (source) trackWa(source);
  const url = waLink(message);
  window.open(url, "_blank", "noopener,noreferrer");
}
